var _rect, _rect2, _rect3, _path, _path2, _ellipse, _circle, _circle2, _circle3, _circle4, _rect4, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect5, _rect6, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg404ErrorPage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 627,
  height: 410,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 574,
  height: 365.687,
  x: 21.992,
  fill: "#8FA90D",
  rx: 32.403
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 546.226,
  height: 337.913,
  x: 35.898,
  y: 13.875,
  fill: "#fff",
  rx: 23.145
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 173.589,
  height: 20.83,
  x: 223.359,
  y: 381.885,
  fill: "#8FA90D",
  rx: 10.415
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ECF0E5",
  d: "M35.898 37.032c0-12.783 10.363-23.145 23.145-23.145h27.775V351.8H59.043c-12.782 0-23.145-10.362-23.145-23.145z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#ECF0E5",
  d: "M86.805 57.86H582.11"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 454.791,
  cy: 37.031,
  fill: "#D9D9D9",
  rx: 11.573,
  ry: 11.572
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 62.507,
  cy: 82.169,
  r: 8.101,
  fill: "#B7D423"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 62.507,
  cy: 116.882,
  r: 8.101,
  fill: "#B7D423"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 62.507,
  cy: 151.605,
  r: 8.101,
  fill: "#B7D423"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 62.507,
  cy: 186.314,
  r: 8.101,
  fill: "#B7D423"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 85.637,
  height: 23.145,
  x: 346.016,
  y: 25.459,
  fill: "#B7D423",
  rx: 11.572
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 61.377,
  cy: 39.354,
  fill: "#D9D9D9",
  rx: 11.573,
  ry: 11.572
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1B",
  d: "M61.44 50.916c6.391 0 11.572-5.18 11.572-11.572S67.832 27.77 61.44 27.77s-11.573 5.182-11.573 11.573 5.181 11.572 11.573 11.572"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#E43625",
  d: "M61.603 35.924a3.47 3.47 0 1 0-.001 6.94 3.47 3.47 0 0 0 .001-6.94m0 5.184a1.714 1.714 0 1 1 0-3.428 1.714 1.714 0 0 1 0 3.428"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7F25",
  d: "M64.41 29.285a3.97 3.97 0 0 0-2.838-1.19 3.97 3.97 0 0 0-2.838 1.19z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "M71.508 42.165a3.97 3.97 0 0 0 1.19-2.837 3.97 3.97 0 0 0-1.19-2.838z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#6F368B",
  d: "M51.471 36.494a3.97 3.97 0 0 0-1.19 2.837c0 1.112.456 2.115 1.19 2.838z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#3091D0",
  d: "M58.734 49.336a3.97 3.97 0 0 0 2.838 1.19 3.97 3.97 0 0 0 2.837-1.19zM64.958 31.3a3.976 3.976 0 0 0-6.724 0z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#6F368B",
  d: "M69.578 42.68a3.976 3.976 0 0 0 0-6.723z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "M53.574 35.957a3.976 3.976 0 0 0 0 6.724z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#54AD47",
  d: "M58.234 47.313a3.976 3.976 0 0 0 6.724 0z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#6F368B",
  d: "M57.688 44.951a1.97 1.97 0 0 1-1.836-1.73h-2.016a3.98 3.98 0 0 0 3.838 3.744z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7F25",
  d: "M67.2 43.17a1.97 1.97 0 0 1-1.731 1.836v2.016a3.98 3.98 0 0 0 3.744-3.838z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "M65.367 33.58a1.97 1.97 0 0 1 1.837 1.73h2.015a3.98 3.98 0 0 0-3.838-3.744z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#E43625",
  d: "M55.85 35.362a1.97 1.97 0 0 1 1.73-1.836V31.51a3.98 3.98 0 0 0-3.744 3.838z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "m53.62 32.025-.078 3.257-1.878.069.04-.958s.655-1.516 1.916-2.368"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#3091D0",
  d: "m69.414 32.002.078 3.256 1.878.07-.04-.958c0-.002-.655-1.517-1.916-2.368"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "m69.414 46.349.078-3.256 1.878-.07-.04.958c0 .002-.655 1.518-1.916 2.368"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#3091D0",
  d: "m53.62 46.376-.078-3.256-1.878-.07.04.958s.655 1.517 1.916 2.368"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#54AD47",
  d: "M54.29 31.31s1.465-1.634 2.404-1.878h1.086l-.01 1.877z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#6F368B",
  d: "M68.918 31.364s-1.466-1.634-2.405-1.878H65.43l.009 1.878z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#E43625",
  d: "M68.918 47.172s-1.466 1.634-2.405 1.878H65.43l.009-1.878z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7F25",
  d: "M54.29 47.104s1.465 1.633 2.404 1.877h1.086l-.01-1.878z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#E43625",
  d: "M59.86 39.541h-1.704v6.77h1.703z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7F25",
  d: "M59.623 35.303a1.965 1.965 0 0 1 3.926 0h2.013a3.98 3.98 0 0 0-3.976-3.875 3.98 3.98 0 0 0-3.977 3.875z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#54AD47",
  d: "M65.547 37.361a1.965 1.965 0 0 1 0 3.926V43.3a3.98 3.98 0 0 0 3.875-3.976 3.98 3.98 0 0 0-3.875-3.976z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#3091D0",
  d: "M57.524 41.287a1.965 1.965 0 0 1 0-3.926v-2.013a3.98 3.98 0 0 0-3.876 3.976 3.98 3.98 0 0 0 3.876 3.976z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE1B",
  d: "M63.441 43.174a1.97 1.97 0 0 1-1.73 1.836v2.016a3.98 3.98 0 0 0 3.744-3.838z"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 85.637,
  height: 23.145,
  x: 480.242,
  y: 25.457,
  fill: "#ECF0E5",
  rx: 11.572
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 450.877,
  height: 256.897,
  x: 107.267,
  y: 80.124,
  stroke: "#ECF0E5",
  rx: 8.101
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#21241E",
  d: "M226.864 238.2q2.376 0 3.96 1.584 1.608 1.584 1.608 3.936 0 2.328-1.608 3.936-1.584 1.584-3.96 1.584h-3.432V255h-2.76v-16.8zm0 8.448q1.224 0 2.016-.816.792-.84.792-2.112t-.792-2.088q-.792-.84-2.016-.84h-3.432v5.856zM243.321 243h2.592v12h-2.592v-1.728q-1.464 2.04-4.2 2.04-2.472 0-4.224-1.824-1.752-1.848-1.752-4.488 0-2.664 1.752-4.488t4.224-1.824q2.736 0 4.2 2.016zm-6.504 8.76q1.08 1.08 2.712 1.08t2.712-1.08q1.08-1.104 1.08-2.76t-1.08-2.736q-1.08-1.104-2.712-1.104t-2.712 1.104q-1.08 1.08-1.08 2.736t1.08 2.76m21.669-8.76h2.544v11.448q0 2.736-1.8 4.2t-4.368 1.464q-4.152 0-5.688-2.904l2.232-1.296q.936 1.848 3.504 1.848 1.68 0 2.616-.888.96-.864.96-2.424v-1.464q-1.464 2.088-4.176 2.088-2.544 0-4.296-1.8-1.752-1.824-1.752-4.392t1.752-4.368q1.752-1.824 4.296-1.824 2.712 0 4.176 2.088zm-6.552 8.568q1.104 1.08 2.736 1.08t2.712-1.08q1.104-1.08 1.104-2.688t-1.104-2.688q-1.08-1.08-2.712-1.08t-2.736 1.08q-1.08 1.08-1.08 2.688t1.08 2.688m14.157-1.464q.288 1.368 1.32 2.112 1.032.72 2.52.72 2.064 0 3.096-1.488l2.136 1.248q-1.776 2.616-5.256 2.616-2.928 0-4.728-1.776-1.8-1.8-1.8-4.536 0-2.688 1.776-4.488 1.776-1.824 4.56-1.824 2.64 0 4.32 1.848 1.704 1.848 1.704 4.488 0 .408-.096 1.08zm-.024-2.112h7.056q-.264-1.464-1.224-2.208-.936-.744-2.208-.744-1.44 0-2.4.792t-1.224 2.16m28.201-9.792h2.76V255h-2.16l-7.92-11.4V255h-2.76v-16.8h2.16l7.92 11.4zm11.611 17.112q-2.64 0-4.488-1.824T299.543 249t1.848-4.488 4.488-1.824q2.664 0 4.488 1.824 1.848 1.824 1.848 4.488t-1.848 4.488q-1.824 1.824-4.488 1.824m-2.664-3.6q1.08 1.08 2.664 1.08t2.664-1.08 1.08-2.712-1.08-2.712-2.664-1.08-2.664 1.08-1.08 2.712 1.08 2.712m17.806-6.216h-2.976v5.76q0 .744.336 1.08.336.312.984.36.672.024 1.656-.024V255q-2.976.36-4.272-.504-1.296-.888-1.296-3.24v-5.76h-2.208V243h2.208v-2.592l2.592-.768V243h2.976zm18.476-4.656h-7.08v4.704h6.84v2.64h-6.84V255h-2.76v-16.8h9.84zm8.077 14.472q-2.64 0-4.488-1.824T341.238 249t1.848-4.488 4.488-1.824q2.664 0 4.488 1.824 1.848 1.824 1.848 4.488t-1.848 4.488q-1.824 1.824-4.488 1.824m-2.664-3.6q1.08 1.08 2.664 1.08t2.664-1.08 1.08-2.712-1.08-2.712-2.664-1.08-2.664 1.08-1.08 2.712 1.08 2.712M364.342 243h2.592v12h-2.592v-1.536q-1.176 1.848-3.72 1.848-2.064 0-3.336-1.32t-1.272-3.624V243h2.592v7.104q0 1.344.72 2.064t1.968.72q1.368 0 2.208-.84.84-.864.84-2.616zm11.935-.312q2.064 0 3.336 1.32t1.272 3.624V255h-2.592v-7.104q0-1.344-.72-2.064t-1.968-.72q-1.368 0-2.208.864-.84.84-.84 2.592V255h-2.592v-12h2.592v1.536q1.176-1.848 3.72-1.848m16.903-4.488h2.592V255h-2.592v-1.728q-1.464 2.04-4.2 2.04-2.472 0-4.224-1.824-1.752-1.848-1.752-4.488 0-2.664 1.752-4.488t4.224-1.824q2.736 0 4.2 2.016zm-6.504 13.56q1.08 1.08 2.712 1.08t2.712-1.08q1.08-1.104 1.08-2.76t-1.08-2.736q-1.08-1.104-2.712-1.104t-2.712 1.104q-1.08 1.08-1.08 2.736t1.08 2.76"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#B7D523",
  d: "M277.04 194.632v10.272h-7.68V217h-11.136v-12.096H225.2v-10.272l23.136-44.832h12L237.2 194.632h21.024V177.16h11.136v17.472zm51.272 14.112q-6.912 9.504-19.392 9.504t-19.488-9.504q-6.912-9.504-6.912-25.344t6.912-25.344q7.008-9.504 19.488-9.504t19.392 9.504q7.008 9.504 7.008 25.344t-7.008 25.344m-19.392-1.248q7.488 0 11.424-6.24t3.936-17.856-3.936-17.856-11.424-6.24q-7.392 0-11.424 6.24-3.936 6.24-3.936 17.856t3.936 17.856q4.032 6.24 11.424 6.24m84.276-12.864v10.272h-7.68V217H374.38v-12.096h-33.024v-10.272l23.136-44.832h12l-23.136 44.832h21.024V177.16h11.136v17.472z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  stroke: "#B7D523",
  d: "m3 406 621 .998"
})));
export { Svg404ErrorPage as ReactComponent };
export default __webpack_public_path__ + "67d481406c09ef1487aa018cce29371d.svg";